// Models
import { TMenuDropdownOption } from 'heeds-ds/src/models'

// React
import { FC, useContext, useState } from 'react'

// Libraries
import { ThemeContext } from 'styled-components'
import { useController, useFormContext } from 'react-hook-form'

// Components
import * as Styled from './styled'
import { DropdownMenu, Icon } from 'heeds-ds'

type Props = {
  actions?: TMenuDropdownOption[]
  active?: boolean
  disabled?: boolean
  label: string
  onChangeName?: (name: string) => void
  onClick: (label: string) => void
  name: string
}

const Tab: FC<Props> = ({
  actions,
  active,
  disabled,
  label,
  onChangeName,
  onClick,
  name,
}) => {
  const { control, setValue, watch } = useFormContext()
  const {
    fieldState: { error },
  } = useController({ control, name })
  const theme = useContext(ThemeContext)

  const [edit, setEdit] = useState(false)

  const handleOnBlur = () => {
    setEdit(false)
  }

  const handleOnKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') setEdit(false)
  }

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(`${name}.name`, event.target.value)
    onChangeName?.(event.target.value)
  }

  return (
    <Styled.Container
      data-testid="tab-container"
      disabled={disabled}
      onClick={() => !disabled && onClick(label)}
    >
      {disabled && <Styled.DisabledBackground />}
      <Styled.LabelContainer onClick={(e) => e.stopPropagation()}>
        {!edit && (
          <Styled.Label
            data-testid="tab-label"
            errors={error !== undefined}
            onClick={() => setEdit(true)}
          >
            {`${watch(`${name}.name`) || ''}`.toUpperCase()}
          </Styled.Label>
        )}
        {edit && (
          <Styled.Input
            data-testid="tab-input"
            onBlur={handleOnBlur}
            onChange={handleOnChange}
            onKeyDown={handleOnKeyDown}
            value={watch(`${name}.name`)}
          />
        )}

        {actions && (
          <DropdownMenu items={actions}>
            <Styled.IconWrapper>
              <Icon
                size={18}
                color={theme.colors.text.default}
                iconName="expandMore"
              />
            </Styled.IconWrapper>
          </DropdownMenu>
        )}
      </Styled.LabelContainer>

      <Styled.IndicatorBar active={active} />
    </Styled.Container>
  )
}

export default Tab
